import { render, staticRenderFns } from "./mutilGoodsList.vue?vue&type=template&id=7a389744&"
import script from "./mutilGoodsList.vue?vue&type=script&lang=js&"
export * from "./mutilGoodsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports